var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.6818 1.5H9.31818C5.00032 1.5 1.5 5.00032 1.5 9.31818V53.6818C1.5 57.9997 5.00032 61.5 9.31818 61.5H53.6818C57.9997 61.5 61.5 57.9997 61.5 53.6818V9.31818C61.5 5.00032 57.9997 1.5 53.6818 1.5Z",
    fill: "white",
    stroke: "#01B187",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7274 25.9695H16.4547V37.4846H19.9092V25.9695H25.6668V37.4846H29.1213V25.9695H34.8788V37.4846H38.3333V25.9695H44.0909V37.4846H47.5454V25.9695H49.2727C50.0337 25.9695 50.7053 25.4713 50.9258 24.7428C51.1463 24.0144 50.8641 23.2273 50.2307 22.8051L32.9581 11.29C32.378 10.9033 31.622 10.9033 31.0419 11.29L13.7693 22.8051C13.1359 23.2273 12.8537 24.0144 13.0742 24.7428C13.2949 25.4713 13.9664 25.9695 14.7274 25.9695Z",
    fill: "#01B187"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2725 40.9395H47.5452H44.0907H38.3332H34.8786H29.1211H25.6666H19.909H16.4545H14.7273C13.7734 40.9395 13 41.7128 13 42.6667V47.2727C13 48.2267 13.7734 49 14.7273 49H49.2725C50.2264 49 50.9997 48.2267 50.9997 47.2727V42.6667C50.9997 41.7128 50.2264 40.9395 49.2725 40.9395Z",
    fill: "#01B187"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPs);
export default __webpack_public_path__ + "static/media/PS.99b65c317a6d8abe86013e704cf6a167.svg";
export { ForwardRef as ReactComponent };